export default "__VITE_ASSET__22f3f7db__"